import type { TypedStoreModule } from '@/types/vuex';
import actions from './actions';
import getters from './getters';
import mutations from './mutations';
import state from './state';

const storeModule = {
  namespaced: true,
  actions,
  getters,
  mutations,
  state,
};


export type SiteSettingsModule = TypedStoreModule<'siteSettings', typeof storeModule>;

export default storeModule;